(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["urbrand-best-sellers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ur-best-sellers')) {
  customElements.define('ur-best-sellers', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.index = 0;
      this.visible = false;
      this.hovered = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.delay = Math.max(4000, Number(this.dataset.interval) || 6000);
      this.pauseButton = this.querySelector('[data-pause]');
      const dismiss = this.querySelector('[data-dismiss]');
      dismiss.hidden = false;
      dismiss.addEventListener('click', () => {
        this.stop();
        this.hidden = true;
        const layout = this.closest('.ur-hero-layout');
        layout?.classList.remove('ur-hero-layout--with-sellers');
        layout?.querySelector('.ur-hero-copy a')?.focus();
      }, options);
      if (this.slides.length < 2) return;
      this.querySelector('[data-controls]').hidden = false;
      this.querySelector('[data-previous]').addEventListener('click', () => this.change(-1, true), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.change(1, true), options);
      this.pauseButton.addEventListener('click', () => this.setPaused(!this.userPaused), options);
      this.addEventListener('pointerenter', () => { this.hovered = true; this.stop(); }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', event => {
        if (event.target !== this.pauseButton) this.setPaused(true);
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.setPaused(true);
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.2 });
      this.observer.observe(this);
      this.updatePause();
    }
    stop() {
      clearTimeout(this.timer);
    }
    schedule() {
      this.stop();
      if (this.slides.length < 2 || this.userPaused || this.hovered || !this.visible || this.hidden || document.hidden) return;
      this.timer = setTimeout(() => this.change(1, false), this.delay);
    }
    updatePause() {
      if (!this.pauseButton) return;
      this.pauseButton.textContent = this.userPaused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
    }
    setPaused(value) {
      this.userPaused = value;
      this.updatePause();
      this.schedule();
    }
    change(direction, manual) {
      if (manual) this.setPaused(true);
      this.slides[this.index].hidden = true;
      this.index = (this.index + direction + this.slides.length) % this.slides.length;
      const slide = this.slides[this.index];
      slide.hidden = false;
      this.querySelector('[data-counter]').textContent = `${this.index + 1} / ${this.slides.length}`;
      if (manual) this.querySelector('[data-announcement]').textContent = slide.dataset.title;
      if (!this.motion.matches) slide.animate([{ opacity: 0.65 }, { opacity: 1 }], { duration: 220 });
      this.schedule();
    }
    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
      this.abortController?.abort();
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
